import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import './Logout.css';
export default function LogoutButton() {
	const { instance } = useMsal();
	const navigate = useNavigate();

	const handleLogout = () => {
		localStorage.removeItem('token');
		localStorage.removeItem('name');
		localStorage.removeItem('email');

		instance
			.logoutRedirect({
				postLogoutRedirectUri: window.location.origin + '/',
			})
			.catch((e) => {
				console.error('Logout failed', e);

				navigate('/');
			});
	};

	return (
		<button onClick={handleLogout} className='logoutButton'>
			Logout
			<svg
				xmlns='http://www.w3.org/2000/svg'
				className='icon icon-tabler icon-tabler-logout'
				width='30'
				height='30'
				viewBox='0 0 24 24'
				strokeWidth='1.2'
				stroke='#FFF'
				fill='none'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<path stroke='none' d='M0 0h24v24H0z' fill='none' />
				<path d='M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2' />
				<path d='M9 12h12l-3 -3' />
				<path d='M18 15l3 -3' />
			</svg>
		</button>
	);
}
